import React, { useState, useEffect } from 'react';
import useDecodeHtml from '../../hooks/useDecodeHtml';
import { Link } from 'react-router-dom';
import { Title, GridContainer, ArticleList, ArticleCard, Sidebar, LoadMoreGrid, LoadMoreContainer, LoadMoreButton, ResponsiveImage } from './LatestNewsStyles';
import { getPrimaryCategoryName, getPrimaryCategoryUrl } from '../../utils/getPrimaryCategory';
import AdSenseSidebar from '../ADSense/AdSenseSidebar/AdSenseSidebar';
import AdSenseArticle from '../ADSense/AdSenseArticle/AdSenseArticle';

const LatestNews = ({
    articles,
    meta,
    onLoadMore,
    title,
    children,
    sidebarChildren,
    maxMobileSidebars = 2,
    disableInitialBlock = false,
}) => {
    const decodeHtml = useDecodeHtml();
    const [loadedBlocks, setLoadedBlocks] = useState([]);
    const [isMobile, setIsMobile] = useState(false);

    const getArticleBlocks = (articles, disableInitialBlock) => {
        const blocks = [];
        let offset = 0;

        if (!disableInitialBlock && articles.length > 0) {
            blocks.push(articles.slice(offset, 6));
            offset = 6;
        }

        while (offset < articles.length) {
            blocks.push(articles.slice(offset, offset + 10));
            offset += 10;
        }
        return blocks;
    };

    useEffect(() => {
        const blocks = getArticleBlocks(articles, disableInitialBlock);
        setLoadedBlocks(blocks);
    }, [articles, disableInitialBlock]);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleLoadMore = async () => {
        if (onLoadMore) {
            await onLoadMore();
        }
    };

    const effectiveChildren = React.Children.toArray(children).length
        ? React.Children.toArray(children)
        : [<AdSenseArticle key="default-ads" />];

    const effectiveSidebarChildren = loadedBlocks.map((_, index) => {
        return Array.isArray(sidebarChildren?.[index])
            ? sidebarChildren[index]
            : [<AdSenseSidebar key={`default-sidebar-${index}`} />];
    });

    return (
        <>
            {title && <Title>{title}</Title>}

            {loadedBlocks.map((block, blockIndex) => (
                <React.Fragment key={`block-${blockIndex}`}>
                    <GridContainer>
                        <ArticleList>
                            {block.map((article, index) => (
                               <ArticleCard key={`article-${blockIndex}-${index}`}>
                               <div className="image-container">
                                <Link to={`/${article.slug}`} style={{ textDecoration: 'none' }}>
                                 <ResponsiveImage
                                   src={article.image}
                                   alt={decodeHtml(article.title)}
                                 />
                                 </Link>
                               </div>
                               <div className="content-container">
                               <Link to={getPrimaryCategoryUrl(article.categories)} style={{ textDecoration: 'none' }}>
                                            <h1 style={{ margin: '0px 0 10px', color: '#CC0000' }}>
                                                {decodeHtml(getPrimaryCategoryName(article.categories))}
                                            </h1>
                                        </Link>
                                        <Link to={`/${article.slug}`} style={{ textDecoration: 'none' }}>
                                            <h1 style={{ margin: 0, marginBottom: '8px' }}>
                                                {decodeHtml(article.title)}
                                            </h1>
                                            <p style={{ margin: '0px 0 10px' }}>{article.excerpt}</p>
                                        </Link>
                                        <Link
                                            to={`/team/${article.author.name.replace(/\s+/g, '-').toLowerCase()}`}
                                            style={{ textDecoration: 'none' }}
                                        >
                                            <p className='paragraph-author'>{`Di ${article.author.name}`}</p>
                                        </Link>
                               </div>
                             </ArticleCard>
                             
                            ))}
                        </ArticleList>

                        {!isMobile && (
                            <Sidebar>
                                {effectiveSidebarChildren[blockIndex].map((sidebarItem, sidebarIndex) => (
                                    <React.Fragment key={`sidebar-${blockIndex}-${sidebarIndex}`}>
                                        {sidebarItem}
                                    </React.Fragment>
                                ))}
                            </Sidebar>
                        )}
                    </GridContainer>

                    <div
                        style={{
                            width: '100%',
                            backgroundColor: '#ffffff',
                            padding: '1rem 0', 
                            margin: '1rem 0'
                        }}
                    >
                        {effectiveChildren[blockIndex] || <AdSenseArticle key={`default-ads-${blockIndex}`} />}
                    </div>
                </React.Fragment>
            ))}

            {meta && meta.current_page < meta.total_pages && (
                <LoadMoreGrid>
                    <LoadMoreContainer>
                        <LoadMoreButton onClick={handleLoadMore}>
                            <p style={{ margin: '0' }}>Carica altri articoli</p>
                        </LoadMoreButton>
                    </LoadMoreContainer>
                </LoadMoreGrid>
            )}

            {isMobile &&
                React.Children.toArray(effectiveSidebarChildren.flat())
                    .slice(0, maxMobileSidebars)
                    .map((child, index) => (
                        <div key={`mobile-sidebar-${index}`} style={{ margin: '16px 0' }}>
                            {child}
                        </div>
                    ))}
        </>
    );
};

export default LatestNews;
